import { FC, useState } from 'react';
import { Training } from '../../models';
import SubModuleCard from '../SubModuleCard/SubModuleCard';
import './ModuleInfo.css';
import HowItWorksPill from '../HowItWorksPill/HowItWorksPill';
import { createPortal } from 'react-dom';
import Modal from '../../pages/Modal/Modal';
import HowItWorksContent from '../HowItWorksContent/HowItWorksContent';

interface ModuleInfoProps {
  training: Training
}

const ModuleInfo: FC<ModuleInfoProps> = ({training}:ModuleInfoProps) => {
  
  const [showHowItWorks, setShowHowItWorks] = useState<boolean>(false)
  const subModCards = training.subModules.map((module, index) => {
    return (
      <SubModuleCard 
        key={index} 
        subModule={module}
        index={index}
      />
    )
  })

  const handleHowItWorksClick = () => {
    setShowHowItWorks(true)
  }
  
  return (
    <div className="ModuleInfo">
      <div className="infoContainer">
        <div className='header'>{`${training.trainingModule} training`.toLocaleUpperCase()}</div>
        <HowItWorksPill onClick={handleHowItWorksClick}/>
        <div style={{fontSize: '16px', marginTop: '18px', userSelect: 'none'}}>Select a topic</div>
        <div className="subModuleCardsContainer">
          {subModCards}
        </div>
        {training.note && <div className="notes">{training.note}</div>}
      </div>
      <div className={`deviceImage ${training.trainingModule.toLowerCase()}`}></div>
      {showHowItWorks &&
        createPortal(
          <Modal 
            onClose={() => setShowHowItWorks(false)}
            allowBackgroundClose={true}
            showCloseButton={false}
            children={<HowItWorksContent content={training.howItWorks ?? []}/>}
            modalStyle={{width: '60vw', padding: '60px 52px'}}
          />,
          document.body
        )
      }
    </div>
  )
};

export default ModuleInfo;
